import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "skiRackFilled"
const SkiRackFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M3.75 19.5H4.5V21H3.75V22.5H2.25V21H1.5V19.5H2.25V1.5H3.75zM21.75 19.5H22.5V21H21.75V22.5H20.25V21H19.5V19.5H20.25V1.5H21.75zM14.23 17.918 13.285 21.444C13.217 21.697 12.957 21.848 12.703 21.78L11.22 21.382C11.142 21.497 11.018 21.578 10.87 21.592L8.081 21.834C7.819 21.858 7.589 21.664 7.566 21.402L7.247 17.766 10.983 17.44V17.442L11.006 17.44 10.971 17.045zM15.492 13.21 14.618 16.47 10.995 15.498 11.87 12.239zM10.852 15.946 7.117 16.272 6.823 12.91 10.558 12.583zM14.102 3.908C14.37 2.908 15.398 2.314 16.398 2.582S17.992 3.878 17.724 4.879L15.88 11.76 12.257 10.79zM7.775 2.287C8.807 2.197 9.717 2.96 9.807 3.992L10.427 11.089 6.693 11.416 6.071 4.318C5.981 3.287 6.744 2.377 7.775 2.287" />
        </svg>
      }
    </span>
  )
}
export default SkiRackFilledIcon
